import { render } from "./PricePage.vue?vue&type=template&id=5a29ecfc&scoped=true"
import script from "./PricePage.vue?vue&type=script&lang=js"
export * from "./PricePage.vue?vue&type=script&lang=js"

import "./PricePage.vue?vue&type=style&index=0&id=5a29ecfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a29ecfc"]])

export default __exports__